import axios from '@/plugins/axios';
import { useToast } from '@/composables/use-toast.js';
import { logApiError } from '@/services/api.js';
const { addToast } = useToast();

const licenseUrl = '/api/licenses';
const listingLicenseUrl = '/api/listing-license';

// Licenses
export const fetchLicenses = async (take, skip) => {
    try {
        const response = await axios.get(`${licenseUrl}?take=${take}&skip=${skip}`);
        return response.data;
    } catch (error) {
        logApiError(error, 'GET', licenseUrl);
        addToast('Error fetching licenses', 'error');
        return false;
    }
}

export const fetchListingLicense = async (listingId) => {
    try 
    {
     const response = await axios.get(`${listingLicenseUrl}/${listingId}`)
     const data = Array.isArray(response.data) ? response.data[0] : response.data;
     return data || null;

    } catch(error) {
        logApiError(error, 'GET', listingLicenseUrl)
        addToast('Error fetching listing license.', 'error');
        return null;
    }
}

export const fetchLicensesOptions = async (tag = null) => {
    try {
        const response = await axios.get(`${licenseUrl}/list`, { params: { tag } });
        return response.data;
    } catch (error) {
        logApiError(error, 'GET', `${licenseUrl}/list`);
        addToast('Error fetching licenses options', 'error');
        return false;
    }
}

export const fetchLicenseById = async (id) => {
    try {
        const response = await axios.get(`${licenseUrl}/${id}`);
        return response.data;
    } catch (error) {
        logApiError(error, 'GET', `${licenseUrl}/${id}`);
        addToast('Error fetching license', 'error');
        return false;
    }
}

export const createLicense = async (data) => {
    try {
        const response = await axios.post(licenseUrl, data);
        return response.data;
    } catch (error) {
        if(error.status === 409) {
            addToast(error.response.data.message, 'error');
        } else {
            logApiError(error, 'POST', licenseUrl);
            addToast('Error creating license', 'error');
        }
        return false;
    }
}

export const updateLicense = async (id, data) => {
    try {
        const response = await axios.post(`${licenseUrl}/${id}`, data);
        return response.data;
    } catch (error) {
        logApiError(error, 'POST', `${licenseUrl}/${id}`);
        addToast('Error updating license', 'error');
        return false;
    }
}

export const deleteLicense = async (id, new_license_id = null) => {
    try {
        const body = new_license_id ? { new_license_id } : {};
        const response = await axios.post(`${licenseUrl}/delete/${id}`, body);
        return response.data;
    } catch (error) {
        logApiError(error, 'POST', `${licenseUrl}/delete/${id}`);
        addToast('Error deleting license', 'error');
        return false;
    }
}